import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Stack,
  Typography,
} from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { RadioGroup, TextInput } from '@/components/inputs'
import {
  checkboxLabelSx,
  COVERAGE_OPTIONS,
  INSURANCE_KIND_OPTIONS,
} from './constants'
import { RcpQuoteFormData } from './schema'

export function StepSeguro() {
  const { control, watch } = useFormContext<RcpQuoteFormData>()
  const insuranceKind = watch('insurance_kind')

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Etapa 3 — Dados do seguro</Typography>

      <RadioGroup
        control={control}
        name="insurance_kind"
        label="Este é um seguro novo ou renovação de outra companhia?"
        options={[...INSURANCE_KIND_OPTIONS]}
      />

      {insuranceKind === 'renewal' && (
        <>
          <TextInput
            control={control}
            name="previous_company_name"
            label="Nome da companhia"
          />
          <TextInput
            control={control}
            name="continuity_date"
            label="Data de continuidade"
            mask="00/00/0000"
            placeholder="dd/mm/aaaa"
          />
        </>
      )}

      <Controller
        name="coverages"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={Boolean(error)} component="fieldset">
            <Typography variant="subtitle1" mb={1}>
              Quais coberturas você quer orçar? Marque um ou mais valores para
              o Limite Máximo de Indenização (LMI) desejado.
            </Typography>
            <FormGroup>
              {COVERAGE_OPTIONS.map((option) => (
                <FormControlLabel
                  key={option.value}
                  control={
                    <Checkbox
                      checked={field.value.includes(option.value)}
                      onChange={(event) => {
                        if (event.target.checked) {
                          field.onChange([...field.value, option.value])
                          return
                        }

                        field.onChange(
                          field.value.filter((item) => item !== option.value),
                        )
                      }}
                    />
                  }
                  label={option.label}
                  sx={checkboxLabelSx}
                />
              ))}
            </FormGroup>
            {error?.message && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )}
      />
    </Stack>
  )
}
